import { Component, Inject, Optional, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Client } from 'app/entities';
import { guardDialogClose } from 'app/helpers/discard-guard';
import { oaDialogConfig } from 'app/helpers/oa-dialog';
import { Observable } from 'rxjs';
import { FormClientCreateOrEditComponent } from '../form-client-create-or-edit/form-client-create-or-edit.component';

export interface ClientFormDialogOptions {
    /** Só nome e WhatsApp à vista; o resto em "Mais dados" (usado pelo orçamento, ORCA-1922). */
    compact?: boolean;
    /** Nome já preenchido (ex.: o que foi digitado na busca de clientes). */
    name?: string;
}

/** Abre o "Adicionar Cliente". Emite o cliente criado (ou undefined, se fechar sem criar). */
export function openClientFormDialog(dialog: MatDialog, options: ClientFormDialogOptions = {}): Observable<Client | undefined> {
    return dialog.open(ClientFormDialogComponent, oaDialogConfig('fullscreen', { width: '750px', autoFocus: false, data: options }))
        .afterClosed();
}

// "Adicionar Cliente" (ORCA-1886): era um mat-menu, que fechava ao tocar fora sem
// confirmar e, no mobile, deixava o título solto por cima do cabeçalho do app.
@Component({
    selector: 'app-client-form-dialog',
    template: `
        <div class="oa-sheet">
            <header class="oa-sheet__header">
                <h2 class="oa-sheet__title" mat-dialog-title>Adicionar Cliente</h2>
                <button type="button" class="oa-icon-btn" (click)="requestClose()" aria-label="Fechar">
                    <mat-icon>close</mat-icon>
                </button>
            </header>

            <div class="oa-sheet__body">
                <app-form-client-create-or-edit #clientForm
                    [compact]="!!options.compact" [initialName]="options.name"
                    (onCreatedClient)="dialogRef.close($event)">
                </app-form-client-create-or-edit>
            </div>

            <footer class="oa-sheet__footer">
                <button type="button" class="oa-btn oa-btn--ghost" (click)="requestClose()">Descartar</button>
                <button type="button" class="oa-btn oa-btn--primary"
                    [disabled]="!clientForm.form?.valid || clientForm.loading" (click)="clientForm.store()">
                    Criar Cliente
                </button>
            </footer>
        </div>
    `,
    styles: [`
        :host { display: flex; flex-direction: column; min-height: 0; }
    `],
})
export class ClientFormDialogComponent {

    @ViewChild('clientForm') clientForm?: FormClientCreateOrEditComponent;
    readonly requestClose: () => void;

    readonly options: ClientFormDialogOptions;

    constructor(
        public dialogRef: MatDialogRef<ClientFormDialogComponent, Client>,
        dialog: MatDialog,
        @Optional() @Inject(MAT_DIALOG_DATA) data: ClientFormDialogOptions | null,
    ) {
        this.options = data || {};
        this.requestClose = guardDialogClose(dialogRef, dialog,
            () => !!this.clientForm?.form?.dirty,
            () => !!this.clientForm?.loading);
    }
}
